"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    type: "VerticalLayout",
    elements: [
        {
            type: "Control",
            scope: "#/properties/visitDate",
            options: {
                disableFuture: true,
            },
        },
        {
            type: "Control",
            label: "Notes",
            scope: "#/properties/notes",
        },
    ],
};
